// extracted by mini-css-extract-plugin
export default {"annotation-history":"lsf-annotation-history","annotation-history__divider":"lsf-annotation-history__divider","history-item":"lsf-history-item","history-item__date":"lsf-history-item__date","history-item_disabled":"lsf-history-item_disabled","history-item_selected":"lsf-history-item_selected","history-item__userpic_prediction":"lsf-history-item__userpic_prediction"};
    if(module.hot) {
      // 1637785522109
      var cssReload = require("/Users/nicholasrq/Git/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  